//#region Imports
/**
To use React and state related functionality
*/
import React from 'react';
/**
 *  It is used to connect a React component to the Redux store.
 */
import { connect } from 'react-redux';
/**
 *  Use Select dropdown
 */
import Select from 'react-select';
/**
 *  It is used for making HTTP requests
 */
import axios from 'axios';
/**
 *  To use GeolocationButton component
 */
import GeolocationButton from './GeolocationButton';
/**
 *  To use Error Wrapper
 */
import withError from '../shared/withError';
//#endregion



class LocationInput extends React.Component {
    constructor(props) {
        super(props);
        //set default state property values
        this.state = {
            //set select dropdown is enabled by default
            disabled: false,
            //set default options array
            options: [],
            //stores user inputs
            input: '',
            //Feature_issue-60 Changes -- Vishal Chauhan  Start 
            
            isStringCoordinates:false,//Enter string is Coordinates or Place name in Textbox
            lat:'',//Stores latitude Value
            long:'',//Stores longitude Value
            fromPlaceName:'',//Stores Display name for From Summary
            toPlaceName:''//Stores Display name for To Summary

            //Feature_issue-60 Changes -- Vishal Chauhan  End
        };
        //Handles onBlur events
        this.onBlur = this.onBlur.bind(this);
        //If user change input then handleInputChange method will trigger
        this.handleInputChange = this.handleInputChange.bind(this);
        //handles change events
        this.handleChange = this.handleChange.bind(this);
    }

    // If we have initialized from a URL (GET) request
    // or permalink, geocode the displayValue
    componentDidMount() {
        if (this.props.value && (!this.props.displayValue)) {       
            //splits the coordinates     
            const coords = this.props.value.split(',').map(parseFloat);
            //fetches places using coordinates
            this.reverseGeocode({ lat: coords[0], lng: coords[1] }).then(res => {
                //set place names
                this.setState({input: res.data.features[0].place_name});
                //Triggeres updateFormField action and sets place name
                this.returnValue(res.data.features[0]);
            }).catch(() => {
                this.returnValue(this.props.value, this.props.value);
            });
        }
    }

    // If the value has been updated elsewhere, geocode the display value
    // I'm not really sure this should be done here, it seems a little fishy
    // logic-wise, consider refactoring
    componentDidUpdate(prevProps) {
        //check if previous coordinates is not same as current coordinates
        if (this.props.value !== prevProps.value) {
            //check if previous place name is same as current placename
            if (this.props.displayValue === prevProps.displayValue) {
                //get coordinates by spliting coordinate value to fetch places name
                const coords = this.props.value.split(',').map(parseFloat);
                //fetches places using coordinates
                this.reverseGeocode({ lat: coords[0], lng: coords[1] }).then(res => {
                    //Triggeres updateFormField action and sets place name
                    this.returnValue(this.props.value, res.data.features[0].place_name);
                }).catch(() => {
                    this.returnValue(this.props.value, this.props.value);
                });
            }
        }
    }

     /**
    * It is written in Planner>>LocationInput.
    * Clear value stored in form
    * @param {String} 'Display value'
    */
    clearValue(displayValue = '') {
        //Triggeres updateFormField action
        this.props.handleChange({
            target: {
                name: this.props.name,
                value: ''
            },
            params: {
                displayValue
            }
        });
    }

    /**
    * It is written in Planner>>LocationInput.
    * Handles error if onGeolocate gets any error
    * @param {Object} 'Error Object'
    */
    returnError(err) {
        //Triggeres updateFormField action
        this.props.handleChange({
            target: {
                //fromPlace or toPlace fiels
                name: this.props.name,
                value: ''
            },
            error: err,
            params: {
                displayValue: ''
            }
        });
    }

    /**
    * It is written in Planner>>LocationInput.
    * Used in the same component.
    * @param {Object} 'Place object'
    * @param {String} 'Place name'
    */
    returnValue(value, displayValue = value.place_name) {
        let newValue;
        if (value.geometry) {
            const coords = value.geometry.coordinates;
            //Feature_issue-60 Changes -- Vishal Chauhan  Start
            //If Entered String is Coordinate then then store display name in a variable for later use
            if(this.state.isStringCoordinates){
                newValue = `${this.state.lat},${this.state.long}`;
                if(this.props.name == "fromPlace"){
                    //This Variable will be used to show From name
                    this.state.fromPlaceName = displayValue;
                }
                if(this.props.name == "toPlace"){
                    //This Variable will be used to show To name
                    this.state.toPlaceName = displayValue;
                }
            }
            else{
                //save coordinates
                newValue = `${coords[1]},${coords[0]}`;
            }
            //Feature_issue-60 Changes -- Vishal Chauhan  End
        } else {
            newValue = value;
        }
        //Feature_issue-60 Changes -- Vishal Chauhan  Start
        //set display value
        displayValue = this.state.isStringCoordinates==true ? `${this.state.lat},${this.state.long}` :displayValue;
        //Feature_issue-60 Changes -- Vishal Chauhan  End
        //creaete target and params object
        let result = {
            target: {
                name: this.props.name,
                value: newValue
            },
            params: {
                displayValue,
            }
        };
        /**
         * The ... operator is used to perform a shallow merge, which means that the properties of the value object are added to the params object without overwriting any existing properties.
         */
        if (value.geometry) {
            result.params = {
                ...result.params,
                ...value
            };
        }
        //handle change event
        //Goes to updateFormField action
        this.props.handleChange(result);
        //sets place name
        this.setState({input: displayValue});
    }

    /**
    * It is written in Planner>>LocationInput .
    * Used in same component.
    * Takes coordinates and returns physical address or place name
    * @param {Object} 'Coordinates'
    * @return {Object} 'Places Names'
    */
    reverseGeocode(coords) {
        return new Promise((resolve, reject) => {
            /**
             * Gets places as per coordinated provided
             * Reverse geocoding in Mapbox is the process of converting geographical coordinates (such as latitude and longitude) into a human-readable physical address or place name.
             */
            let apiURL = `https://api.mapbox.com/geocoding/v5/mapbox.places/${coords.lng},${coords.lat}.json?access_token=${this.props.config.mapboxToken}`;
            //make reverse geocode mapbox request
            const reverseGeocodeRequest = axios.create({
                baseURL: apiURL,
                headers: {
                    'content-type': 'application/json',
                    'accept': 'application/json'
                }
            });
            //makes request
            reverseGeocodeRequest.get()
                .then(res => {
                    //return results
                    resolve(res);
                })
                .catch(err => {
                    reject(err);
                });
        });
    }

    /**
    * It is written in Planner>>LocationInput .
    * Used in same component.
    * Takes search value and fetch locations names. Also it can take coordinate as an input and return location names.
    * @param {Object} 'Search Value'
    * @return {Object} 'Places Names'
    */
    forwardGeocode(term, callback) {
        return new Promise((resolve, reject) => {
            //Feature_issue-60 Changes -- Vishal Chauhan  Start 
            //if the search value is not black then trip value
            if(term != "")
                term = term.trim()
            //Feature_issue-60 Changes -- Vishal Chauhan  End
            //encodes a string for use in a URL.
            const encodedSearch = encodeURIComponent(term);
            //sets mapbox key
            const mapboxKey = this.props.config.mapboxToken;
            //Feature_issue-60 Changes -- Vishal Chauhan  Start 
            //Make Mapbox api call as per Entered value
            //check if search string is coordinate or place name
            if(isCoordinates(term))
            {   //store latitude
                var latitude = term.split(",")[0]
                //store longitude
                var longitude = term.split(",")[1]
                //store latitude and longitude in state
                this.state.long = longitude
                this.state.lat = latitude
                //Create url to get places name using coordinates
                var apiURL = `https://api.mapbox.com/geocoding/v5/mapbox.places/${longitude},${latitude}.json?access_token=${mapboxKey}`;   
                //set isStringCoordinates value to the state
                this.setState({isStringCoordinates : true})
            }               
            else
            {
                //Create url to get places name using searched place name
                var apiURL = `https://api.mapbox.com/geocoding/v5/mapbox.places/${encodedSearch}.json?access_token=${mapboxKey}`;  
                //set isStringCoordinates value to the state              
                this.setState({isStringCoordinates : false})
            }
            //Feature_issue-60 Changes -- Vishal Chauhan  End
            // if the swBounds and neBounds properties of the config prop are defined.
            if (this.props.config.swBounds && this.props.config.neBounds) {
                //  creates a new variables and assigns it the value of the config prop, with the swBounds and neBounds properties extracted
                const { swBounds, neBounds } = this.props.config;
                //Update apiURL with swBounds, neBounds Coordinates
                apiURL += `&bbox=${swBounds.lng},${swBounds.lat},${neBounds.lng},${neBounds.lat}`;
            }
            //Creates request object
            const forwardGeocodeRequest = axios.create({
                baseURL: apiURL,
                headers: {
                    'content-type': 'application/json',
                    'accept': 'application/json'
                }
            });
            //Make get request to fetch places names
            forwardGeocodeRequest.get()
                .then(res => {
                    //returns places name
                    resolve(res.data.features);
                })
                .catch(err => {
                    reject(err);
                });

        })
    }

    /**
    * It is written in Planner>>LocationInput .
    * Used in same component.
    * Handles user input to search place name
    * @param {String} 'Search Value'
    * @param {Object} 'Input value action type'
    */
    handleInputChange(string, action) {
        //check if triggered action of input control 
        if (action.action === "input-change") {
            //sets input string 
            this.setState({ input: string });
            //check string length
            if (string && string.length > 2) {
                //get places names
                this.forwardGeocode(string)
                    .then(res => {
                        //set places name as list in input as suggestions
                        this.setState({ options: res });
                    });
            }
        }
    }

    //handles input control change event
    handleChange(value, event) {
        //Triggeres updateFormField action and sets place name
        this.returnValue(value);
    }

    //trigers when user click on onGeolocate button
    onGeolocate(res) {
        // If loading, disable this input until either result
        // or error is returned.
        if (res.loading) {
            //disable input button
            this.setState({ disabled: true });
            //Clear value stored in form
            this.clearValue('Loading...');
            return;
        }
        //If user has did not allow to take current location
        if (res.error) {
            //enable input button
            this.setState({ disabled: false });
            //handles error
            this.returnError(res.error);
            return;
        }
        // Return coordinate value. Attempt to reverse geocode; if it fails, display coordstring
        const { lat, lng } = res.coords;
        //extracts the first 10 characters from the lat and lng
        const coordString = `${lng.toString().substr(0, 10)},${lat.toString().substr(0, 10)}`;
        this.returnValue(coordString);
        //gets places name from coordinates
        this.reverseGeocode(coordString)
            .then(res => {
                //enable input button
                this.setState({ disabled: false });
                //set place name and update Form field
                this.returnValue(coordString, res[0].formatted_address);
            })
            .catch(() => {
                //enable input button
                this.setState({ disabled: false });
                this.returnValue(coordString, coordString);
            });
    }

    // If we have a value entered in the field, but no lat/lng for it yet
    // attempt to geocode the location name.
    onBlur() {
        if (!this.props.value && this.state.options && this.state.input) {
            //Feature_issue-60 Changes -- Vishal Chauhan  Start 
            //if state.options have value then set first value to the input
            if(this.state.options.length>0){
                this.returnValue(this.state.options[0]);
            }                
            //Feature_issue-60 Changes -- Vishal Chauhan  End
        }
    }

    //gets the value of the input control
    getOptionValue = (option) => {
        //check if option have geometry property
        if (option.geometry) {
            //take coordinates
            const coords = option.geometry.coordinates;
            //save coordinate string
            const newOption = `${coords[1]},${coords[0]}`;
            return newOption;
        }
        //FIXME
        return '';
    }

    render() {
        //destructuring props values
        const { name, fields, showSummary, title, placeholder, displayValue, geocode } = this.props;

        //check show summary or not
        if (showSummary) {
            //Feature_issue-60 Changes -- Vishal Chauhan  Start
            var updatedDisplayValue = displayValue;
            //check if input value is coordinate or place name
            if(this.state.isStringCoordinates)
            {   //Check field name
                if(name == "fromPlace"){
                    //save display value for from Place name
                    updatedDisplayValue = this.state.fromPlaceName
                }
                else{
                    //save display value for to Place name
                    updatedDisplayValue = this.state.toPlaceName
                }
            }
            //Feature_issue-60 Changes -- Vishal Chauhan  End
            return (
                <div className="otp-location-summary">
                    {/* Feature_issue-60 Changes -- Vishal Chauhan (Below Line) */}
                    {title}: {formatSummary(updatedDisplayValue)}
                </div>
            );
        }

        return (
            <div className="otp-form-control otp-has-btn">
                <label htmlFor={name} className="screen-reader-text">{title}</label>
                <div className="autocomplete-form-control">
                    <Select
                        onInputChange={this.handleInputChange}
                        onChange={this.handleChange}
                        // loadOptions={this.forwardGeocode}
                        value={fields[name]}
                        inputValue={this.state.input}
                        placeholder={placeholder}
                        name={name}
                        id={name}
                        disabled={this.state.disabled}
                        onBlur={this.onBlur}
                        options={this.state.options}
                        getOptionLabel={option => option.displayValue || option.place_name}
                        getOptionValue={this.getOptionValue}
                    ></Select>
                </div>
                <GeolocationButton
                    handleClick={e => this.onGeolocate(e)}
                />
            </div>
        );
    }
}

// Some utilities

const formatSuggestion = (suggestion) => {
    if (suggestion.terms.length > 3) {
        const shortSuggestion = suggestion.terms.slice(0, -2).map(term => term.value);
        return shortSuggestion.join(', ');
    }
    return suggestion.description;
};
/*
Format summary text.
The function first splits the string into an array of strings, using the , character as the delimiter. 
If the length of the array is greater than 2, the function then returns the first two elements of the array, joined together with a , character. Otherwise, the function simply returns the string.
*/
const formatSummary = displayValue => { 
    const chopped = displayValue.split(',');
    if (chopped.length > 2) {
        return chopped.slice(0, 2).join(',');
    }
    return displayValue;
};

//Feature_issue-60 Changes -- Vishal Chauhan  Start 
//Detect if string is Coordinates or not
const isCoordinates = (str) => {
    const coordinatesRegex = /^-?\d{1,2}(?:\.\d{1,15})?,\s?-?\d{1,3}(?:\.\d{1,15})?$/;
    return coordinatesRegex.test(str);
}
//Feature_issue-60 Changes -- Vishal Chauhan  End

//sets default props
LocationInput.defaultProps = {
    placeholder: 'Enter Address or Intersection',
    disabled: false,
    displayValue: ''
};

/**
 * 
 extract the config,geocode and fields property from the state object that are needed by the component.
 */
const mapStateToProps = state => {
    return {
        config: state.config,
        geocode: state.geocode,
        fields: state.form.fields
    };
};

export default connect(mapStateToProps)(withError(LocationInput));
 